let Url = {
  getRedirectParameter() {
    let url = window.location.href;

    if (url.indexOf('Logoff') > -1) {
      return null;
    }

    let regex = new RegExp('[?&]ReturnUrl(=([^]*)|&|#|$)');
    let results = regex.exec(url);

    if (!results || !results[2]) {
      return null;
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  addReturnUrlParameter(url) {
    let redirectUrl = this.getRedirectParameter();

    if (redirectUrl !== null) {
      if (redirectUrl.substring(0, 1) !== '/') {
        redirectUrl = '' + redirectUrl;
      }
      if (redirectUrl.indexOf('ReturnUrl=') > -1) {
        let split = redirectUrl.split('ReturnUrl=');
        redirectUrl = url + '?ReturnUrl=' + split[1];
      }
      else {
        redirectUrl = url + '?ReturnUrl=' + redirectUrl;
      }
    } else {
      redirectUrl = url;
    }

    return redirectUrl;
  },

  storeRedirectUrl() {
    let existing = this.getRedirectUrlFromStore();

    if (existing == null) {
      this.updateRedirectUrlInStore();
    }
  },

  updateRedirectUrlInStore() {
    let redirectUrl = this.getRedirectParameter();

    if (redirectUrl != null) {
      localStorage.setItem('sso-redirecturl', redirectUrl);
    }
  },

  getRedirectUrlFromStore() {
    if (localStorage.getItem('sso-redirecturl') !== null) {
      return localStorage.getItem('sso-redirecturl');
    } else {
      return null;
    }
  },

  removeUrlFromStorage() {
    if (localStorage.getItem('sso-redirecturl') !== null) {
      localStorage.removeItem('sso-redirecturl');
    }
  },

  getMsalRedirect () {
    let href = window.location.href;

    return href.indexOf("?") > 0
      ? href.substring(0, href.indexOf("?"))
      : href.indexOf("#") > 0
        ? href.substring(0, href.indexOf("#"))
        : href;
  }
};

export default Url;
